var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSimpliBotMenuIcon = function SvgSimpliBotMenuIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "white",
    stroke: "#121619"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12086_23532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00985 12.1851C9.86841 12.1851 12.1857 9.86777 12.1857 7.00921C12.1857 4.15066 9.86841 1.83334 7.00985 1.83334C4.1513 1.83334 1.83398 4.15066 1.83398 7.00921C1.83398 9.86777 4.1513 12.1851 7.00985 12.1851Z",
    fill: "url(#paint0_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00985 12.1851C9.86841 12.1851 12.1857 9.86777 12.1857 7.00921C12.1857 4.15066 9.86841 1.83334 7.00985 1.83334C4.1513 1.83334 1.83398 4.15066 1.83398 7.00921C1.83398 9.86777 4.1513 12.1851 7.00985 12.1851Z",
    fill: "url(#paint1_linear_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01063 11.833C9.70565 11.833 11.8904 9.64828 11.8904 6.95326C11.8904 4.25823 9.70565 2.07349 7.01063 2.07349C4.31561 2.07349 2.13086 4.25823 2.13086 6.95326C2.13086 9.64828 4.31561 11.833 7.01063 11.833Z",
    fill: "url(#paint2_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89131 11.833C8.96491 11.833 10.6459 10.152 10.6459 8.07844C10.6459 6.00484 8.96491 4.32385 6.89131 4.32385C4.81771 4.32385 3.13672 6.00484 3.13672 8.07844C3.13672 10.152 4.81771 11.833 6.89131 11.833Z",
    fill: "url(#paint3_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66114 7.33346C8.3835 8.61121 6.68135 8.9806 5.85951 8.15866C5.03768 7.33671 5.40707 5.63467 6.68471 4.35702C7.96235 3.07938 9.6644 2.70989 10.4863 3.53183C11.3083 4.35377 10.9388 6.05582 9.66114 7.33346Z",
    fill: "url(#paint4_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.96303 7.45746C7.13889 9.06543 5.28301 9.76032 3.81784 9.00936C2.35267 8.2584 1.83292 6.34614 2.65696 4.73817C3.481 3.1302 5.33698 2.43531 6.80215 3.18627C8.26732 3.93723 8.78718 5.84949 7.96303 7.45746Z",
    fill: "url(#paint5_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.97078 9.65039C7.49334 10.582 6.32952 10.9391 5.37129 10.448C4.41306 9.95689 4.0233 8.80367 4.50074 7.87201C4.97817 6.94034 6.14199 6.58334 7.10022 7.07443C8.05845 7.56551 8.44821 8.71883 7.97078 9.65039Z",
    fill: "url(#paint6_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79983 10.7932C8.16351 11.5595 6.17638 10.7702 5.36148 9.03025C4.54657 7.29029 5.21248 5.25844 6.8488 4.49215C8.48512 3.72586 10.4722 4.51514 11.2872 6.2551C12.1021 7.99505 11.4361 10.0268 9.79983 10.7932Z",
    fill: "url(#paint7_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32177 4.60093C7.35296 5.38486 6.53217 6.05402 5.48837 6.0956C4.44456 6.13718 3.57306 5.53543 3.54188 4.7515C3.51069 3.96757 4.33148 3.2984 5.37528 3.25682C6.41909 3.21524 7.29059 3.817 7.32177 4.60093Z",
    fill: "url(#paint8_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.779 6.52967C10.5455 6.98526 9.57949 6.95649 8.62126 6.46541C7.66303 5.97432 7.07555 5.20688 7.30897 4.75128C7.54238 4.29569 8.50849 4.32446 9.46672 4.81554C10.4249 5.30663 11.0125 6.07407 10.779 6.52967Z",
    fill: "url(#paint9_radial_12086_23532)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.17073 7.52958C2.32928 8.47679 2.83601 9.18134 3.30263 9.10322C3.76925 9.0251 4.01894 8.19392 3.86039 7.24682C3.70184 6.29961 3.19511 5.59506 2.72849 5.67318C2.26197 5.7512 2.01218 6.58238 2.17073 7.52958Z",
    fill: "url(#paint10_radial_12086_23532)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.8439 6.85102) scale(5.17594)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#007394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4718,
    stopColor: "#03637F",
    stopOpacity: 0.9106
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5863,
    stopColor: "#094457",
    stopOpacity: 0.7133
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6987,
    stopColor: "#0D2C37",
    stopOpacity: 0.5195
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#101A20",
    stopOpacity: 0.3327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9095,
    stopColor: "#121013",
    stopOpacity: 0.156
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130C0E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12086_23532",
    x1: 1.83396,
    y1: 7.00921,
    x2: 12.1857,
    y2: 7.00921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7606,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8507,
    stopColor: "#150E10",
    stopOpacity: 0.1881
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8831,
    stopColor: "#1B1517",
    stopOpacity: 0.2559
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9063,
    stopColor: "#272022",
    stopOpacity: 0.3042
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#373133",
    stopOpacity: 0.3433
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#4D4749",
    stopOpacity: 0.3768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9552,
    stopColor: "#676364",
    stopOpacity: 0.4064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#878384",
    stopOpacity: 0.4332
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9798,
    stopColor: "#ABA9AA",
    stopOpacity: 0.4579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9903,
    stopColor: "#D3D2D2",
    stopOpacity: 0.4798
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.01063 6.95324) scale(4.87974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7902,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8696,
    stopColor: "#150E0E",
    stopOpacity: 0.2465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8982,
    stopColor: "#1C130D",
    stopOpacity: 0.3353
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9186,
    stopColor: "#271D0D",
    stopOpacity: 0.3986
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9351,
    stopColor: "#382B0C",
    stopOpacity: 0.4498
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9492,
    stopColor: "#4E3D0A",
    stopOpacity: 0.4936
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9617,
    stopColor: "#6A5409",
    stopOpacity: 0.5325
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9731,
    stopColor: "#8A6F07",
    stopOpacity: 0.5676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9834,
    stopColor: "#B08E05",
    stopOpacity: 0.5999
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9927,
    stopColor: "#D9B002",
    stopOpacity: 0.6286
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD000",
    stopOpacity: 0.6512
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.89024 8.07906) rotate(-75.6289) scale(3.75451)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1878,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4952,
    stopColor: "#150D0E",
    stopOpacity: 0.246
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.606,
    stopColor: "#1C0E0D",
    stopOpacity: 0.3346
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6849,
    stopColor: "#27120D",
    stopOpacity: 0.3978
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7487,
    stopColor: "#38170C",
    stopOpacity: 0.4489
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8034,
    stopColor: "#4E1D0A",
    stopOpacity: 0.4927
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8519,
    stopColor: "#6A2509",
    stopOpacity: 0.5315
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8957,
    stopColor: "#8A2E07",
    stopOpacity: 0.5665
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    stopColor: "#B03905",
    stopOpacity: 0.5987
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9717,
    stopColor: "#D94402",
    stopOpacity: 0.6274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4F00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.17224 5.84628) rotate(45) scale(2.1048 3.27188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD7C00",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#DF7A00",
    stopOpacity: 0.5617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7598,
    stopColor: "#E67400",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9027,
    stopColor: "#F16A00",
    stopOpacity: 0.6305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.3091 6.09862) rotate(27.1376) scale(2.98111 3.27185)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4881,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6807,
    stopColor: "#150E10",
    stopOpacity: 0.2446
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7501,
    stopColor: "#1B1517",
    stopOpacity: 0.3327
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7996,
    stopColor: "#272022",
    stopOpacity: 0.3955
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8396,
    stopColor: "#373133",
    stopOpacity: 0.4463
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8739,
    stopColor: "#4D4749",
    stopOpacity: 0.4898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    stopColor: "#676364",
    stopOpacity: 0.5283
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9317,
    stopColor: "#878384",
    stopOpacity: 0.5632
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9569,
    stopColor: "#ABA9AA",
    stopOpacity: 0.5952
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9793,
    stopColor: "#D3D2D2",
    stopOpacity: 0.6237
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.23579 8.76169) rotate(27.1376) scale(1.94957 1.89541)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    stopColor: "white",
    stopOpacity: 0.8587
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.32225 7.64329) rotate(64.9069) scale(3.47881 3.27186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDD700",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5234,
    stopColor: "#DED500",
    stopOpacity: 0.5547
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    stopColor: "#E3CE00",
    stopOpacity: 0.5924
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8463,
    stopColor: "#ECC300",
    stopOpacity: 0.6193
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9541,
    stopColor: "#F8B200",
    stopOpacity: 0.6408
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.43163 4.67579) rotate(-2.28393) scale(1.89143 1.42052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4881,
    stopColor: "#130C0E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#102639",
    stopOpacity: 0.0252
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5305,
    stopColor: "#0C3F62",
    stopOpacity: 0.0538
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5557,
    stopColor: "#095688",
    stopOpacity: 0.0859
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5832,
    stopColor: "#076AA8",
    stopOpacity: 0.1208
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6136,
    stopColor: "#057AC4",
    stopOpacity: 0.1594
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#0387DA",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#0292EB",
    stopOpacity: 0.2539
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7376,
    stopColor: "#0199F6",
    stopOpacity: 0.3168
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8071,
    stopColor: "#009DFD",
    stopOpacity: 0.405
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFF",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.63487 5.65781) rotate(27.1376) scale(1.94957 0.927005)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6374,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_12086_23532",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.01558 7.38821) scale(1.37082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD7C00",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5586,
    stopColor: "#DF7A00",
    stopOpacity: 0.5617
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7598,
    stopColor: "#E67400",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9027,
    stopColor: "#F16A00",
    stopOpacity: 0.6305
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5E00",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12086_23532"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(1.75 1.75)"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSimpliBotMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "simpliBotMenuIcon.6596066.svg";